<template>
  <q-form
    class="san-form"
    @submit.prevent="onSubmit"
  >
    <template
      v-for="(slot, slotName) in $slots"
      #[slotName]="scope"
      :key="slotName"
    >
      <slot
        :name="slotName"
        v-bind="scope || {}"
      />

      <div
        v-if="showBanner && !isEmpty(errors)"
        class="san-form--error-banner"
      >
        <SanFormErrorBanner :errors="errors" />
      </div>

      <div class="san-form--action-buttons">
        <SanButton
          type="submit"
          color="primary"
          size="md"
          :label="okButton.label"
          :disabled="!isDirty || !isValid"
          fullwidth
          unelevated
          @click="onSubmit"
        >
          <!-- <Tooltip>{{ okButton.tooltip }}</Tooltip> -->
        </SanButton>

        <SanButton
          type="reset"
          color="grey"
          size="md"
          :label="cancelButton.label"
          :disabled="!isDirty"
          fullwidth
          unelevated
          @click="onReset"
        >
          <!-- <Tooltip>{{ cancelButton.tooltip }}</Tooltip> -->
        </SanButton>
      </div>
    </template>
  </q-form>
</template>

<script setup>
import { isEmpty } from 'lodash'
import SanFormErrorBanner from '@/components/forms/SanFormErrorBanner.vue'
import { useFormValidation } from '@/composables'

defineOptions({ name: 'SanFormStatic' })
const errors = defineModel('errors', { type: Object, default: () => ({}) })
const emit = defineEmits(['submit'])
const props = defineProps({
  okButton: { type: Object, default: () => ({ label: 'Ok', tooltip: 'Proceed.' }) },
  cancelButton: { type: Object, default: () => ({ label: 'Cancel', tooltip: 'Give up.' }) },
  showBanner: { type: Boolean, default: true }
})

const { isDirty, isValid, onReset, onSubmit } = useFormValidation(props, emit)
</script>
